const messages = {
  pt: {
    required: 'Preencha este campo.', email: 'Informe um endereço de e-mail válido.', url: 'Informe um endereço de site válido.',
    invalid: 'Confira o valor informado neste campo.',
    short: n => 'Use pelo menos ' + n + ' caracteres.', long: n => 'Use no máximo ' + n + ' caracteres.',
    min: n => 'Informe um valor maior ou igual a ' + n + '.', max: n => 'Informe um valor menor ou igual a ' + n + '.',
  },
  es: {
    required: 'Completa este campo.', email: 'Introduce una dirección de correo electrónico válida.', url: 'Introduce una dirección web válida.',
    invalid: 'Revisa el valor de este campo.',
    short: n => 'Usa al menos ' + n + ' caracteres.', long: n => 'Usa como máximo ' + n + ' caracteres.',
    min: n => 'Introduce un valor mayor o igual que ' + n + '.', max: n => 'Introduce un valor menor o igual que ' + n + '.',
  },
  en: {
    required: 'Please fill in this field.', email: 'Enter a valid email address.', url: 'Enter a valid website address.',
    invalid: 'Check the value entered in this field.',
    short: n => 'Use at least ' + n + ' characters.', long: n => 'Use no more than ' + n + ' characters.',
    min: n => 'Enter a value greater than or equal to ' + n + '.', max: n => 'Enter a value less than or equal to ' + n + '.',
  },
};

export function nativeValidationMessage(field, language) {
  const copy = messages[String(language || '').split('-')[0]] || messages.en;
  const validity = field.validity;
  if (validity.valueMissing) return copy.required;
  if (validity.typeMismatch) return field.type === 'email' ? copy.email : field.type === 'url' ? copy.url : copy.invalid;
  if (validity.tooShort) return copy.short(field.minLength);
  if (validity.tooLong) return copy.long(field.maxLength);
  if (validity.rangeUnderflow) return copy.min(field.min);
  if (validity.rangeOverflow) return copy.max(field.max);
  return copy.invalid;
}

/** Keep browser validation in the interface language without replacing app validators. */
export function installNativeValidation(doc, getLanguage) {
  const owned = new Set();
  const clear = event => {
    if (!owned.has(event.target)) return;
    event.target.setCustomValidity('');
    owned.delete(event.target);
  };
  const invalid = event => {
    const field = event.target;
    if (!field.validity || typeof field.setCustomValidity !== 'function') return;
    if (field.validity.customError && !owned.has(field)) return;
    for (const previous of owned) if (!previous.isConnected) owned.delete(previous);
    field.setCustomValidity(nativeValidationMessage(field, getLanguage()));
    owned.add(field);
  };
  doc.addEventListener('invalid', invalid, true);
  doc.addEventListener('input', clear, true);
  doc.addEventListener('change', clear, true);
  return () => {
    for (const field of owned) field.setCustomValidity('');
    owned.clear();
    doc.removeEventListener('invalid', invalid, true);
    doc.removeEventListener('input', clear, true);
    doc.removeEventListener('change', clear, true);
  };
}
